import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VarulesComponent } from '../varules/varules.component';
import { I } from '@angular/cdk/keycodes';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { ModalTabVisibilityService } from '../services/modal-tab-visibility.service';

declare const copyToClipboard: any;
@Component({
  selector: 'app-nonvitalcore',
  templateUrl: './nonvitalcore.component.html',
  styleUrls: ['./nonvitalcore.component.scss']
})
export class NonvitalcoreComponent implements OnInit, OnDestroy {


  SearchTypes: string[] = ["Handler", "GroupId", "VendorName"];
  autocompleteForm: any;
  selectedSearchType: any;
  deploymentItemsList = [];
  deploymentSelected: string = '';
  searchTypeSelected: string = '';
  public reactiveFormdeployment: FormGroup;
  public reactiveFormType: FormGroup;
  searchQuery: string = '';
  handlerresponseArray: [];
  routeName = "";
  failedMessageNote: string = '';

  handlerProperties = [
    { name: 'Description', displayName: 'Description'},
    { name: 'Direction', displayName:'Direction'},
    { name: 'localOutboundFolder', displayName: 'Local Outbound Folder'},
    { name: 'localOutboundBckFolder', displayName:'Local Outbound Bck Folder'},
    { name: 'localSourceFolder', displayName: 'Local Source Folder'},
    { name: 'localProcessingFolder', displayName: 'Local Processing Folder'},
    { name: 'localFailedFolder', displayName: 'Local Failed Folder'},
    { name: 'localSuccessFolder', displayName: 'Local Success Folder'},
    { name: 'localIgnoredFolder', displayName: 'Local Ignored Folder'},
    { name: 'dateWiseFolderFormat', displayName: 'DateWiseFolderFormat'},
    { name: 'fileTypes', displayName: 'FileTypes'},
    { name: 'isActive', displayName: 'IsActive'},
    { name: 'groupID', displayName: 'GroupID'},
    { name: 'msh', displayName: 'MSH'},
    { name: 'GoLiveDate', displayName: 'GoLiveDate'},
    { name: 'vendorName', displayName: 'Vendor Name'},
    { name: 'Message', displayName: 'Message'},
    { name: 'Type', displayName: 'Type'},
    { name: 'EndDate', displayName: 'EndDate'},
    { name: 'System', displayName: 'System'},
    { name: 'Projectid', displayName: 'ProjectId'},
    { name: 'isTCPC', displayName: 'IsTCPC'},
    { name: 'TestMode', displayName: 'TestMode'},
    { name: 'MessageSubtype', displayName: 'MessageSubtype'},
    { name: 'OwnerLabOrgID', displayName: 'OwnerLabOrgID'},
    { name: 'FindFileIn', displayName: 'FindFileIn'},
    { name: 'ArchivePath', displayName: 'ArchivePath'},
    { name: 'ShowMessage', displayName: 'ShowMessage'},
    { name: 'Id', displayName: 'Id'},
    { name: 'InterfaceName', displayName: 'InterfaceName'}
  ];

  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'non-core';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    public service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private modalService: NgbModal,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService

  ) {
    this.reactiveFormdeployment = this._formBuilder.group({ deploymentname: ['', Validators.required] });
    this.reactiveFormType = this._formBuilder.group({ SearchType: ['', Validators.required] });
  }

  ngOnInit() {
    this.autocompleteForm = this._formBuilder.group({
      searchType: ['']
    })
    this.getDeployments();
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-nonvitalcore-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
  }
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }

  onSearchTypeSelected(selectedValue: any) {
    this.selectedSearchType = selectedValue;
  }
  getDeployments() {
    this.service.getDeployments("Deployments").subscribe(
      (data) => {
        if (data.length > 0) {
          this.deploymentItemsList = data;
        } else if (data.length === 0) {
          this.deploymentItemsList = [];
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }
  selectdeploymentEvent(item: any) {
    this.deploymentSelected = item;
  }
  selectSearchType(item: any) {
    this.searchTypeSelected = item;
  }
  cleareddeployment(event) {
    this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }
  clearSearchType(event) {
    this.searchTypeSelected = '';
    this.reactiveFormType.reset();
    this.reactiveFormType.patchValue({ "SearchType": '' });
    this.reactiveFormType.patchValue(this.SearchTypes);
  }
  clearSearch(): void {
    this.searchQuery = '';
  }
  async getHandlers() {
    if (this.deploymentSelected != '' && this.searchTypeSelected != "" && this.searchQuery != '' ) {
      let objmapping = {
        "Type": this.searchTypeSelected,
        "SearchKey": this.searchQuery,
        "dep": this.deploymentSelected
      }
      //  if (this.searchQuery.length<=2) {
      //   this.toastr.error('Please enter minimum 3 characters to search', "", {
      //     timeOut: 4000,
      //     positionClass: 'toast-bottom-right'
      //   })
      // }
    if(this.searchQuery.length>=2){
      
    this.ngxUiLoaderService.start();
      this.handlerresponseArray = await this.service.dxpostapi("api/VitalHubDXAPI/GetNonVitalCoreInterfaces", objmapping);
      this.ngxUiLoaderService.stop();
    }
    else  {
      this.toastr.error('Please enter minimum 3 characters to search', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    }

     
      if (this.handlerresponseArray.length == 0) {

        this.ngxUiLoaderService.stop();
        this.toastr.error('No Result found for the search criteria', "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        return false;
      }

    }
    else if (this.deploymentSelected == '') {
      this.toastr.error('Deployemt key is mandatory', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    }
    else if (this.searchTypeSelected == '') {
      this.toastr.error('Please select the search type in Type section', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    }
    else if (this.searchQuery == '') {
      this.toastr.error('Please enter value in search bar', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    }


  }

  handlerPopUp(handlerPopup) {
    const handlerModalRef = this.modalService.open(handlerPopup, { windowClass: "modalConfig", backdrop: 'static', keyboard: false });
    this.currentModalRefs.push(handlerModalRef);
    
    handlerModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== handlerModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== handlerModalRef);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    this.modalTabVisibility.tagOwned('data-nonvitalcore-modal', 'modalConfig');
    
    this.modalWasOpen = true;
  }
  async clearnotepopupvalues() {
    this.failedMessageNote = '';
  }
  async closenote(h) {
    await this.clearnotepopupvalues();
    h('close modal');
  }
  getVaRule(handler: any) {

    let dataToruleModal = {
      routename: handler,
      deploymentkey: this.deploymentSelected,
      enableedit: true
    };
    const vaRuleModalRef = this.modalService.open(VarulesComponent,
      { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
    vaRuleModalRef.componentInstance.inputDataInModalComponent = dataToruleModal;
    this.currentModalRefs.push(vaRuleModalRef);
    
    vaRuleModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== vaRuleModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== vaRuleModalRef);
      }
    );
    
    // Add data attribute to identify the modal and backdrop
    this.modalTabVisibility.tagOwned('data-nonvitalcore-modal', 'myCustomModalClass');
    
    this.modalWasOpen = true;

  }
  submitReset() {
    this.searchQuery = '';
    // this.searchTypeSelected='';
    // this.deploymentSelected='';
    this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
    this.reactiveFormType.reset();
    this.searchTypeSelected = '';
    this.reactiveFormType.reset();
    this.reactiveFormType.patchValue({ "SearchType": '' });
    this.reactiveFormType.patchValue(this.SearchTypes);
    this.handlerresponseArray = [];
  }

  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }


    
  }

  hideModals() {
    const result = this.modalTabVisibility.hideOwned('data-nonvitalcore-modal', {
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['modalConfig', 'myCustomModalClass'],
    });
    this.modalWasOpen = result.modalWasOpen;
  }

  showModals() {
    this.modalTabVisibility.showOwned('data-nonvitalcore-modal', {
      modalWasOpen: this.modalWasOpen,
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['modalConfig', 'myCustomModalClass'],
    });
  }

}

